import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import AppLayout from '../../components/layout/app-layout/app-layout';
import BackButton from '../../components/shared/BackButton/BackButton';
import appState from '../../state/AppStateContainer';
import TableTopActions from '../app-supplier-database/supplier-database-top-actions';
import { useInboxCount } from '../app-supplier-database/useInboxCount';
import { fromOf, wizardUrl } from '../../util/evaluationsNavigation';
import styles from './page-supplier-evaluations.module.scss';

type Props = {
  view: 'overview' | 'new' | 'detail';
  path?: string[];
  backTo?: string;
  children?: ReactNode;
};

const EvaluationsLayout: FC<Props> = ({ view, path, backTo, children }) => {
  const [t] = useTranslation('supplierDatabase');
  const history = useHistory();
  const location = useLocation();
  const inboxCount = useInboxCount();
  const registerUrl = `${appState._getCurrentOrgUrl()}/supplier-database`;
  const toRegisterPath = (subPath: string) => history.push(`${registerUrl}${subPath}`);

  // The wizard's from is the entry behind it, so stepping back keeps a copy of it off the history.
  const goBackTo = () => {
    if (!backTo) return;
    if (view === 'new' && fromOf(location.state) === backTo) history.goBack();
    else history.push(backTo);
  };

  return (
    <AppLayout
      title={path ? <BackButton path={path} onClick={goBackTo} /> : t('pageTitle', 'Leverantörer')}
    >
      <div className="column-content supplier-table-wrapper">
        <TableTopActions
          evaluationsView={view}
          onTabChange={(tab: number) => history.push(registerUrl, { tab })}
          onSelectMonitoring={toRegisterPath}
          onSelectEvaluations={toRegisterPath}
          onNewEvaluation={() =>
            history.push(wizardUrl(), { from: `${location.pathname}${location.search}` })
          }
          inboxCount={inboxCount}
          isReadOnlyUser={appState.isReadOnlyAccessRole()}
        />
        <div className={styles.page}>{children}</div>
      </div>
    </AppLayout>
  );
};

export default EvaluationsLayout;
